module.exports = __webpack_public_path__ + "static/media/photo.6b3b4d50.svg";